
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

interface Props {
  title: string
  content: string
}

export const ProductTypeInfo = (props: Props) => {
  const [expanded, setExpanded] = React.useState(false)
  return (
    <div>
        <p>
          <button type="button" className="btn btn-link pl-0" onClick={() => setExpanded(!expanded)}>
            <FontAwesomeIcon icon={faChevronRight} className="mr-3"/>
            {props.title}
          </button>
        </p>
        {expanded && 
          <p className="ml-3 pl-3">
            {props.content}
          </p>
        }
    </div>
  )
}
